import R from "ramda";

export const splitCategories = (categories) => {
  const { trackingCodes, passedCategories } = selectTrackingCodeCategories(categories);
  const { glCodes, newPassedCategories } = selectGlCodeCategories(passedCategories);
  const newCategories = selectNewCategories(newPassedCategories);
  return { glCodes, newCategories, trackingCodes };
};

const selectTrackingCodeCategories = (categories) => {
  const trackingCodes = categories.filter(doesCategoryStartWithTrackingPrefix);
  const passedCategories = R.difference(categories, trackingCodes);
  return { trackingCodes, passedCategories };
};
const selectGlCodeCategories = (passedCategories) => {
  const glCodes = passedCategories.filter(doesCategoryStartWithGlPrefix);
  const newPassedCategories = R.difference(passedCategories, glCodes);
  return { glCodes, newPassedCategories };
};

const selectNewCategories = (categories) => categories.filter(excludedCategories);

const doesCategoryStartWithTrackingPrefix = (category) => {
  const trackingPrefixes = ["Xerov2 Tracking", "MYOB ARLive Job"];
  return trackingPrefixes.some(tracking => category.name.startsWith(tracking));
};

export const doesCategoryStartWithGlPrefix = (category) => {
  const glPrefixes = ["Xero", "MYOB", "SageOne", "QBO", "SaasuV2"];
  return glPrefixes.some(gl => category.name.startsWith(gl));
};

const excludedCategories = (category) => {
  const excluded = ["Exported", "Export failed", "Do not export", "Xero", "MYOB", "SageOne", "QBO", "SaasuV2"];
  return excluded.every(ex => !category.name.startsWith(ex));
};

export const excludeDisplayCategories = (categories) => {
  const displayCategories = [];
  const excludedDisplayCategories = ["Exported", "Xero", "MYOB", "SageOne", "QBO", "SaasuV2"];
  categories.forEach(category => {
    if (!excludedDisplayCategories.some(ex => category.startsWith(ex))) {
      displayCategories.push(category);
    }
  });
  return displayCategories;
};



// WEBPACK FOOTER //
// ./src/js/utils/split-categories.js